<div *ngIf="showProgressBar">
  <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
</div>
<div align="center" class="title">
  <h3>Power Supply SFP</h3>
  <b>Supply Name: </b>{{supplyName}} &nbsp;
  &nbsp;
  <b>Location: </b> {{sysContact}}
  <br>
  <b>Location Information: </b> {{sysLocation}} &nbsp;
</div>
<br>
<mat-dialog-content class="mat-typography" align="center">
  <div>
    <form id="sfpsupplyFormGroup" [formGroup]="sfpsupplyFormGroup">
      <div class="scanner-container">
        <!--QR Scan Code with zoom features-->
        <zxing-scanner #scanner
                       *ngIf="scannerEnabled"
                       id="qr-reader"
                       [zoom]="zoom"
                       (scanSuccess)="scanSuccessHandler($event)">
        </zxing-scanner>
        <div *ngIf="zoomFlag" class="focus-frame"></div>
        <div *ngIf="zoomFlag" class="zoom-controls">
          <i aria-hidden="true" class="fa fa-search-plus" (click)="zoomIn()">
            <b>ZoomIn</b>
          </i>
          <i aria-hidden="true" class="fa fa-search-minus" (click)="zoomOut()">
            <b>ZoomOut</b>
          </i>
        </div>
      </div>
      <div class="d-flex align-items-start mt-1">
      <button mat-mini-fab
        style="background-color: transparent;color: black;float: left;" class="fa fa-qrcode fa-2x"
        aria-hidden="true" (click)="enableScanner()"></button>&nbsp;&nbsp;
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput
               formControlName="sfpMac"
               placeholder="MacAddress as Printed on the SFP"
               (keydown.space)="$event.preventDefault()">
        <mat-error *ngIf="sfpsupplyFormGroup.get('sfpMac').errors?.required">
          MacAddress as Printed on the SFP is <strong>required</strong>
        </mat-error>
      </mat-form-field>
      </div>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Vendor" formControlName="vendor">
      </mat-form-field>

      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Model" formControlName="model">
      </mat-form-field>

      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Serial Number" formControlName="serialNo">
      </mat-form-field>

      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Hardware Revision"
          formControlName="hardwarerevision">
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput (keydown.space)="$event.preventDefault()" placeholder="Boot File Version"
          formControlName="bootfileversion">
      </mat-form-field>
      <mat-form-field class="mat-form-field-infix-class">
        <input matInput
               formControlName="sfpipv4"
               placeholder="SFP IPV4"
               (keydown.space)="$event.preventDefault()">
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button cdkFocusInitial  [disabled]="sfpsupplyFormGroup.invalid" (click)="saveSFPSupplyChanges()">Save</button>
</mat-dialog-actions>
